import type { Technique } from '../types';
import { TEXT_FROM_TEXT_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, type TextFromTextState } from './render';

export const textFromText: Technique<TextFromTextState> = {
  id: 'text-from-text',
  name: 'Text aus Text',
  category: 'deconstruction',
  description: 'Füllt die Buchstaben mit fortlaufendem Kleintext entlang Zeilen, Spiralen oder der Kontur.',
  params: TEXT_FROM_TEXT_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  elementCount,
};
